import React from 'react';
import { Quote } from 'lucide-react';
import { useScrollTracking } from '../hooks/useScrollTracking';
import { trackExternalLink } from '../utils/mixpanel';
const companies = [{
  name: 'Blissway',
  website: 'https://www.blissway.com/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9Fx5sKdZ6S2eBQoDpYCtCn/blissway_dark.png'
}, {
  name: 'XBow Systems',
  website: 'https://www.xbowsystems.com/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/un5D9aLWBDDG3mNVaPADVK/xbow_dark.png'
}, {
  name: 'Aclarity',
  website: 'https://www.aclaritywater.com/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9PzzAzmceZfV28tE4WNuZR/aclarity.png'
}, {
  name: 'Flightdeck',
  website: 'https://flightdecksolutions.com/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3rKFVSNQqt6wPb6YEW6fkn/FLIGHTDECK.png'
}];
const testimonials = [{
  quote: 'Thruline is the easiest way to match our engineering data with our business ERP data.',
  author: 'XBow Systems'
}, {
  quote: "Previously we didn't have a good way to connect engineering and business data.",
  author: 'Flightdeck Solutions'
}, {
  quote: 'Thruline lets us track projects across engineering and operations in one place.',
  author: 'Blissway'
}];
export function SocialProof() {
  const sectionRef = useScrollTracking('testimonials');
  const handleCompanyLogoClick = (companyName: string, website: string) => {
    trackExternalLink(`${companyName} Logo`, website, 'testimonials');
  };
  return <section ref={sectionRef as any} className="py-24 px-6 bg-white" data-id="element-169">
      <div className="max-w-7xl mx-auto" data-id="element-170">
        <div className="text-center mb-16" data-id="element-171">
          <h2 className="text-4xl font-bold text-slate-900" data-id="element-172">
            Trusted by advanced manufacturers
          </h2>
        </div>

        {/* Customer logos - Greyscale YC style */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20" data-id="element-173">
          {companies.map((company, index) => <a key={index} href={company.website} target="_blank" rel="noopener noreferrer" onClick={() => handleCompanyLogoClick(company.name, company.website)} className="flex items-center justify-center p-6 bg-white rounded-lg border border-slate-200 hover:border-slate-300 transition-all group" data-id="element-174">
              <img src={company.logo} alt={company.name} className="max-h-8 w-auto grayscale opacity-60 group-hover:opacity-80 transition-opacity" data-id="element-175" />
            </a>)}
        </div>

        {/* Testimonials - YC style */}
        <div className="grid md:grid-cols-3 gap-8" data-id="element-176">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-slate-50 rounded-lg p-6 border border-slate-200" data-id="element-177">
              <Quote className="w-6 h-6 text-slate-400 mb-4" data-id="element-178" />
              <p className="text-base text-slate-700 leading-relaxed mb-4" data-id="element-179">
                "{testimonial.quote}"
              </p>
              <div className="text-sm font-semibold text-slate-900" data-id="element-180">
                — {testimonial.author}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}